import {color_black, color_grey_light, color_grey_ultra_light, color_transparent, color_white} from "../../../../constants/colors";

export const styles = {
    weeklyTasksModalContainer: {
        width: 430,
        height: 560,
        backgroundColor: color_white,
        borderRadius: 20,
        display: "flex",
        flexDirection: "column",
        gap: 12,
        padding: 16,
        boxSizing: "border-box"
    },
    weeklyTasksModalTaskContainer: {
        width: "100%",
        maxWidth: "100%",
        boxSizing: "border-box",
        minHeight: 72,
        backgroundColor: color_grey_ultra_light,
        color: color_black,
        display: "flex",
        alignItems: "flex-start",
        gap: 8,
        borderRadius: 10,
        padding: 10,
        marginBottom: 10,
        flexDirection: "row"
    },
    weeklyTasksModalTextArea: {
        resize: "none",
        height: 72,
        width: "100%",
        padding: 0,
        border: "0px solid transparent",
        textAlign: "start",
        flexGrow: 1,
        backgroundColor: color_transparent,
        borderColor: "transparent",
        WebkitBoxShadow: "none",
        MozBoxShadow: "none",
        boxShadow: "none",
        outline: "none",
        fontFamily: 'Onest'
    }
}